import { removeCommas, validateAmount, validateInputAmount } from '../../../../client/Juno/helpers';
import AmountWithCurrency from '../../common/AmountWithCurrency';
import CustomSelect from '../../common/CustomSelect';
import JunoButton from '../../common/JunoButton';
import { filterNetworkSpecificAddresses } from './sendHelpers';
import SendModalChooser from './SendModalChooser';
import PropTypes from 'prop-types';

const SendForm = ({
    isModal,
    setAmount,
    selectedCrypto = {},
    amount = {},
    setSelectedCrypto,
    cryptoList = [],
    allAddresses = {},
    modals = {},
    setModals,
    balancesCrypto,
    getCryptoAddress,
    onClose,
    fetchUsersAddress,
}) => {
    // handle amount with validations
    const handleAmountChange = e => {
        const value = validateInputAmount(removeCommas(e.target.value));
        const total =
            parseFloat(value) > 0
                ? parseFloat(
                      (parseFloat(value) + parseFloat(selectedCrypto?.selectedBlockainFee)).toFixed(
                          8,
                      ),
                  )
                : parseFloat(value);

        const cryptoRangeError = validateAmount(
            total,
            0,
            selectedCrypto?.selected?.currencyShortName,
            balancesCrypto,
        );

        setAmount(prev => ({
            ...prev,
            value,
            error: cryptoRangeError,
            total,
        }));
    };

    const networkSpecificBlockchain =
        selectedCrypto?.selected?.currencyShortName == 'USDT'
            ? [{ currencyShortName: 'Ethereum' }, { currencyShortName: 'Tron' }]
            : [
                  {
                      currencyShortName: selectedCrypto?.selected?.blockchain,
                  },
              ];

    return (
        <>
            <div className="flex gap-2.5 flex-col h-full">
                <div
                    className={`self-stretch w-full ${
                        isModal
                            ? ''
                            : 'bg-modal-bg p-3 h-[444px] border border-[#E4E4E7] dark:!border-0 bg-quickforms-bg'
                    } rounded-lg inline-flex flex-col justify-start items-center gap-6`}>
                    <AmountWithCurrency
                        isErrorVisible={true}
                        errorMessage={amount.error}
                        transactionLabel="From wallet"
                        data={cryptoList}
                        type="Send"
                        selected={selectedCrypto?.selected}
                        bottomLabel={selected => selected?.blockchain}
                        onCurrencyChange={selected =>
                            setSelectedCrypto(prev => ({
                                ...prev,
                                selected,
                                loading: true,
                            }))
                        }
                        onAmountChange={handleAmountChange}
                        amountValue={amount.value}
                    />
                    {selectedCrypto?.selected?.currencyShortName == 'USDT' ? (
                        <CustomSelect
                            label="Network"
                            options={networkSpecificBlockchain}
                            value={{
                                currencyShortName: selectedCrypto?.selectedBlockain,
                            }}
                            onChange={selectedBlockchain => {
                                setSelectedCrypto(prev => ({
                                    ...prev,
                                    selectedBlockain: selectedBlockchain?.currencyShortName,
                                }));
                                fetchUsersAddress(selectedBlockchain?.currencyShortName);
                            }}
                        />
                    ) : null}
                    <CustomSelect
                        value={
                            selectedCrypto?.selectedToAddressFormated
                                ? {
                                      currencyShortName: selectedCrypto?.selectedToAddressFormated,
                                  }
                                : { currencyShortName: 'NO ADDRESS FOUND' }
                        }
                        label="To"
                        options={filterNetworkSpecificAddresses(
                            allAddresses.addresses || [],
                            selectedCrypto?.selectedBlockain,
                        )}
                        disabled={selectedCrypto?.loading}
                        onChange={selectedAddress => {
                            setSelectedCrypto(prev => ({
                                ...prev,
                                selectedToAddress: selectedAddress.address,
                                selectedToAddressFormated: selectedAddress.currencyShortName,
                                selectedToAddressName: selectedAddress.name,
                            }));
                        }}
                        rightLabel={'add new address'}
                        rightOnCLick={() => {
                            setModals(prev => ({
                                ...prev,
                                open: true,
                                current: 'addNewAddress',
                            }));
                        }}
                    />
                </div>
                {!isModal ? (
                    <JunoButton
                        type="widget"
                        disabled={
                            amount.error ||
                            !amount.value ||
                            !selectedCrypto?.selectedToAddress ||
                            selectedCrypto.loading
                        }
                        onClick={() => {
                            setModals({
                                open: true,
                                current: 'review',
                            });
                        }}>
                        Continue
                    </JunoButton>
                ) : null}
            </div>
            {!isModal ? (
                <SendModalChooser
                    fetchUsersAddress={fetchUsersAddress}
                    modals={modals}
                    setModals={setModals}
                    setAmount={setAmount}
                    selectedCrypto={selectedCrypto}
                    allAddresses={allAddresses}
                    setSelectedCrypto={setSelectedCrypto}
                    cryptoList={cryptoList}
                    balancesCrypto={balancesCrypto}
                    amount={amount}
                    getCryptoAddress={getCryptoAddress}
                    onClose={() => {
                        setAmount({ value: '', error: null });

                        const options = filterNetworkSpecificAddresses(
                            allAddresses.addresses || [],
                            selectedCrypto?.selectedBlockain,
                        );

                        const firstOption = options?.[0];

                        setSelectedCrypto(prev => ({
                            ...prev,
                            selected: cryptoList?.[0],
                            selectedBlockain: cryptoList?.[0]?.blockchain,
                            selectedToAddress: firstOption?.address,
                            selectedToAddressFormated: firstOption?.currencyShortName,
                            selectedToAddressName: firstOption?.name,
                        }));

                        if (onClose) {
                            onClose();
                        }
                    }}
                />
            ) : null}
        </>
    );
};

SendForm.propTypes = {
    isModal: PropTypes.bool,
    setAmount: PropTypes.func,
    selectedCrypto: PropTypes.object,
    amount: PropTypes.object,
    setSelectedCrypto: PropTypes.func,
    cryptoList: PropTypes.array,
    allAddresses: PropTypes.object,
    modals: PropTypes.object,
    setModals: PropTypes.func,
    fetchUsersAddress: PropTypes.func,
};

export default SendForm;
